export default "__VITE_ASSET__GusxX2xH__"